
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class PendingLeituraList extends Vue {
  @Prop({ type: String }) readonly title!: string;
  @Prop({ type: Array }) readonly headers!: any[];
  @Prop({ type: Array }) readonly items!: any[];
  @Prop({ type: Boolean }) readonly loading!: boolean;
  @Prop({ type: String }) readonly loadingText!: string;
  @Prop({ type: Boolean }) readonly hideDefaultFooter!: boolean;
  @Prop({ type: Boolean }) readonly dense!: boolean;

  isOpen = false;
}
